import { Box, Typography } from '@mui/material'
import LoadingMessage from '@/components/feedbacks/LoadingMessage'
import { useGetMediaFile } from '@/features/cwsdirect/useGetMediaFile'

export function CwsDirectPage() {
  const { isAuthenticated, isLoading, isSuccess, isError } = useGetMediaFile()

  if (!isAuthenticated) {
    return <LoadingMessage isAuthMessage />
  }

  if (isLoading) {
    return <LoadingMessage isDownloadMessage />
  }

  return (
    <Box sx={{ p: 4 }}>
      {isSuccess && <Typography>Download successful.</Typography>}
      {isError && <Typography>Access denied or file not found.</Typography>}
    </Box>
  )
}
